import { cn } from "@omni/utils/styles";
import { useState } from "react";

import { HitsPerPageConfig } from "@/components/Search/SearchResults/StateComponents/HitsPerPage/hitsPerPage.container";

type HitsPerPageComponentProps = {
    items: Array<HitsPerPageConfig>;
    refinedItem?: HitsPerPageConfig;
    refine: (value: number) => void;
    className?: string;
};

const HitsPerPageComponent = ({
    items,
    refine,
    refinedItem,
    className
}: HitsPerPageComponentProps) => {
    const [optimisticValue, setOptimisticValue] = useState<
        HitsPerPageConfig | undefined
    >(refinedItem);

    const handleOnClickHitsPerPageItem = (item: HitsPerPageConfig) => () => {
        setOptimisticValue(item);
        refine(item.value);
    };

    return (
        <ul className={cn("tw:flex tw:gap-2 tw:mb-0!", className)}>
            {items.map((item) => (
                <li key={`hitsPerPage-item-${item.value}`}>
                    <button
                        type={"button"}
                        className={cn(
                            "tw:border-none tw:underline-offset-4",
                            "tw:hover:underline tw:focus:underline",
                            {
                                "tw:underline":
                                    item.value === optimisticValue?.value
                            }
                        )}
                        onClick={handleOnClickHitsPerPageItem(item)}
                    >
                        {item.label}
                    </button>
                </li>
            ))}
        </ul>
    );
};

export { HitsPerPageComponent };
